"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECENT_ATTEMPTS_COUNT = exports.RATING_VALUES = exports.PROFICIENCY_LABELS = exports.PROFICIENCY_KEYS = void 0;
exports.PROFICIENCY_KEYS = {
    NOT_STARTED: 'not-started',
    NEEDS_WORK: 'needs-work',
    IN_PROGRESS: 'in-progress',
    MASTERED: 'mastered',
};
exports.PROFICIENCY_LABELS = (_a = {},
    _a[exports.PROFICIENCY_KEYS.NOT_STARTED] = 'Not started',
    _a[exports.PROFICIENCY_KEYS.NEEDS_WORK] = 'Needs work',
    _a[exports.PROFICIENCY_KEYS.IN_PROGRESS] = 'In progress',
    _a[exports.PROFICIENCY_KEYS.MASTERED] = 'Mastered',
    _a);
// Proficiency score value of each rating
exports.RATING_VALUES = {
    correct: 2,
    retire: 2,
    'more-work': 1,
    wrong: 0,
};
// The number of recent attempts to use
// in proficiency score calculations
exports.RECENT_ATTEMPTS_COUNT = 3;
//# sourceMappingURL=constants.js.map